import React, { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import Title from '../../components/Title/index';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRedeemInfo } from '../../services/app/redeem-service';
import { useQuery } from "react-query";
import { errorHandler } from "../../utils/network/error-handler";
import { Box, Grid } from '@mui/material';
import { AxiosError } from "axios";
import { isObject } from 'lodash'


const PageContent = styled('div')(({ theme }) => ({
  marginBottom: '3rem',
}));

const BoxedContent = styled('div')(({ theme }) => ({
  top: '50%',
  left: '20%',
  position: 'relative',
  width: '60vw',
}))

const CenteredTypoGraphy = styled('div')(({ theme }) => ({
  textAlign: 'center',
  marginTop: '2rem'
}))

const RedeemDetailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [ redeemUuid, setRedeemUuid ] = useState('');
  const [ filteredKeys, setFilteredKeys ] = useState<any>()
  const [ userKeys, setUserKeys ] = useState<any>()

  useEffect(() => {
    const urlArray = location?.pathname?.split('/');
    const uuid = urlArray[urlArray.length - 1];

    uuid && setRedeemUuid(uuid);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useQuery(['redeemInfo'], () => getRedeemInfo(redeemUuid),{
    onSuccess: (data: any) => {
      const { user } = data;
      let keys = Object.keys(data);
      let userKeys = Object.keys(user);
      let nonObjectArr: any = [];
      let userKeysArray: any = [];

      keys?.forEach((key: any) => {
        if(!isObject(data[`${key}`])){
          const result = key.replace(/([A-Z])/g, " $1");
          const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
          nonObjectArr.push({
            name: key,
            data: data[key],
            title: finalResult
          })
        }
      });

      setFilteredKeys(nonObjectArr);

      userKeys?.forEach((key: any) => {
        if(!isObject(data[`${key}`])){
          const result = key.replace(/([A-Z])/g, " $1");
          const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
          userKeysArray.push({
            name: key,
            data: data[key],
            title: finalResult
          })
        }
      });

      setUserKeys(nonObjectArr);
    },
    onError: (err: AxiosError) => errorHandler(err, navigate),
    enabled: redeemUuid ? true : false
  })

  return (
    <>
      <PageContent>
        <Title title='Redeem Details'/>    
      </PageContent>

      <Box>
        <BoxedContent>
          <CenteredTypoGraphy>
            <h1>
              Redeem Info
            </h1>
          </CenteredTypoGraphy>
          {
            filteredKeys?.map((key: any) => {
              return (
                <Grid container spacing={3}>
                  <Grid item pl={20} xs={6} sm={6} lg={6}>
                    <h3>{key.title}</h3>
                  </Grid>
                  <Grid item pl={20} xs={6} sm={6} lg={6}>
                    <p>{key.data || "Null"}</p>
                  </Grid>
                </Grid>
              )
            })
          }

          <CenteredTypoGraphy>
            <h1>
              User Info
            </h1>
          </CenteredTypoGraphy>

          {
            userKeys?.map((key: any) => {
              return (
                <Grid container spacing={3}>
                  <Grid item pl={20} xs={6} sm={6} lg={6}>
                    <h3>{key.title}</h3>
                  </Grid>
                  <Grid item pl={20} xs={6} sm={6} lg={6}>
                    <p>{key.data || "Null"}</p>
                  </Grid>
                </Grid>
              )
            })
          }


        </BoxedContent>
      </Box>
    </>
  )

}

export default RedeemDetailPage;